/**
 * @Author: v_jppjpeng
 * @Date: 2024-11-30 17:43:20
 * @Explain: 搜索框
 */
import { Icon } from '@/components/tdesign';
import { intlGet } from '@/locales';
import classNames from 'classnames';
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { Input, Link } from 'tdesign-react';
// utils
import { setTimeOut } from '@/utils/common';
// type
import type { InputSizeType } from '../data.d';
import { InputSizeEnum } from '../data.d';

type PropsType = {
  className?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  borderless?: boolean;
  size?: InputSizeType;
  isFixed?: boolean;
  autofocus?: boolean;
  searchIconPre?: boolean; // 搜索按钮前置
  onChange?: (value: string) => void;
  onSearch?: (value: string) => void;
  onClear?: () => void;
  onKeyup?: () => void;
  onKeydown?: () => void;
  onPaste?: () => void;
};

function SearchBox(props: PropsType, refs: any) {
  const {
    className,
    value,
    placeholder = intlGet('COMMON.SEARCH'),
    disabled,
    borderless = true,
    size = InputSizeEnum.S,
    isFixed,
    autofocus,
    searchIconPre,
    onChange,
    onSearch,
    onClear,
    onKeyup,
    onKeydown,
    onPaste,
  } = props;
  const searchBoxRef = useRef<any>(null);

  const onFocus = () => {
    setTimeOut(() => {
      searchBoxRef.current?.focus();
    });
  };

  useEffect(() => {
    if (autofocus) {
      onFocus();
    }
  }, [autofocus]);

  // 绑定ref，抛出方法
  useImperativeHandle(refs, () => ({
    onFocus,
  }));
  return (
    <Input
      ref={searchBoxRef}
      className={classNames(
        {
          'default-td-search-box': true,
          'model-one': true,
          [`size-${size}`]: size,
          'is-fixed': isFixed,
        },
        className,
      )}
      prefixIcon={
        searchIconPre ? (
          <Link hover="color" onClick={() => onSearch?.(value || '')}>
            <Icon.Font name="input-search" color="#333" />
          </Link>
        ) : undefined
      }
      suffixIcon={
        <>
          {value && (
            <Link
              hover="color"
              onClick={() => {
                onChange?.('');
                onClear ? onClear?.() : onSearch?.('');
              }}
            >
              <Icon.Font name="solid-circle-x" />
            </Link>
          )}
          {!searchIconPre && (
            <Link hover="color" onClick={() => onSearch?.(value || '')}>
              <Icon.Font name="input-search" />
            </Link>
          )}
        </>
      }
      disabled={disabled}
      borderless={borderless}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      onKeydown={onKeydown}
      onKeyup={onKeyup}
      onEnter={onSearch}
      onPaste={onPaste}
    />
  );
}

export default forwardRef(SearchBox);
